export class HomeTitle {
  #title: HTMLHeadingElement | null = null;
  #lastKnownScrollPosition: number = 0;
  #ticking: boolean = false;
  constructor() {
    this.#title = document.querySelector<HTMLHeadingElement>('h1.site-title');
  }
  init() {
    if (!this.#title) return;
    document.addEventListener('scroll', this.#handleScroll);
  }
  dispose() {
    document.removeEventListener('scroll', this.#handleScroll);
  }
  #handleScroll = () => {
    this.#lastKnownScrollPosition = window.scrollY;
    if (!this.#ticking) {
      window.requestAnimationFrame(() => {
        this.#checkScroll(this.#lastKnownScrollPosition);
        this.#ticking = false;
      });
      this.#ticking = true;
    }
  };
  #checkScroll(scrollY: number) {
    if (scrollY > 100) {
      this.#title?.classList.add('js--scrolled');
    } else {
      this.#title?.classList.remove('js--scrolled');
    }
  }
}
